window.addEventListener("beforeunload",function(){
  window.scrollTo(0, 0);
});
(function ($) {


const Init = (() => {

  // settings
  
  
  let website       = {},
      load          = {},
      resize        = {},
      resizeW       = {},
      scroll        = {},
      orientation   = {},
      mod           = {},
      anime         = {},
      scrollOption  = {},
      parallax      = {},
      drawer        = {},
      wp            = {},
      slider        = {},
      pjax          = {},
      tab           = {},
      accordion     = {},
      megamenu      = {},
      iscroll       = {},
      cursor        = {},
      webgl         = {},
      page          = {};
  
  website = {
    domain: document.domain,
    page: document.getElementById('js-container').dataset.barbaNamespace,
    url: document.URL,
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
    scrollY: window.pageYOffset,
    scrollCurrent: 0,
    scrollHeight: 0,
    scrollHiddenHeight: 0,
    scrollRate: 0,
    viewport: document.querySelector('meta[name="viewport"]').getAttribute('content'),
  
    breakpoint: { 
      pc: 1200, 
      tb: 992, 
      sp: 768,
      ss: 576,
      min: 375
    },
    ua: window.navigator.userAgent.toLowerCase(),
    entry: performance.getEntriesByType("navigation")[0].type,
    referrer: document.referrer ? new URL(document.referrer) : null,
    isDesktop     : true,
    isTablet      : false,
    isMobile      : false,
    isFirst       : true,
    isTouch       : 'ontouchstart' in window || navigator.maxTouchPoints,
    tabletView    : false,
    // tabletView    : 1240,
  
    animationFrame: null,
    headId        : 'js-header',
    footId        : 'js-footer',
  
    act: 'is-act',
    inact: 'is-inact',
    actView: 'is-view',
    actOpen: 'is-open',
    current: 'is-current',
    loaded: 'is-loaded',
    hide: 'is-hide',
  
    targetAnime: 'js-anime',
    actAnime: 'is-anime',
    shiftPoint: 0,
    shiftPc: 3,
    shiftSp: 4,
  };
  website.headElm = document.getElementById(website.headId);
  website.footElm = document.getElementById(website.footId);
  website.shiftPoint = website.breakpoint.tb;
  
  website.isLocal = website.domain === 'localhost' || website.domain === 'maa-recruit.demo';
  
  ready = {
    functions: [],
    length: 0,
  };
  
  load = {
    functions: [],
    length: 0,
  };
  
  resize = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  resizeW = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  orientation = {
    functions: [],
    length: 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  page = {
    common: [],
    home  : [],
  };
  
  const debug = (value) => {
    if(website.isLocal) {
      if(typeof value === 'string') {
        console.log(`!--  ${value} --!`)
      } else {
        console.log(value);
      }
    }
  }

  //modules
  
  const WinReady = {
  
    init() {
      window.addEventListener('DOMContentLoaded', function (e) {
        WinReady.update();
      });
  
      debug('ready init');
    },
  
    add(func) {
      ready.functions.push(func);
      ready.length = load.functions.length;
    },
  
    remove(func) {
      ready.functions.splice(func, 1);
      ready.length = ready.functions.length;
    },
  
    update() {
      for (let i = 0; i < ready.length; i++) {
        let func = ready.functions[i];
        func();
      }
    },
  
  }
  
  
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function (e) {
        WinLoad.update();
      });
  
      debug('load init');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      for (let i = 0; i < load.length; i++) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function (e) {
        if (!resize.isRunning) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame(WinResize.update);
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      debug('resize init');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      // website.winWidth = window.innerWidth;
      // website.winHeight = window.innerHeight;
      website.ua = navigator.userAgent.toLowerCase();
  
      for (let i = 0; i < resize.length; i++) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  
  const WinResizeWidth = {
  
    init() {
      window.addEventListener('resize', function (e) {
        if (website.winWidth != window.innerWidth && !resizeW.isRunning) {
          resizeW.isRunning = true;
          resizeW.animationFrame = window.requestAnimationFrame(WinResizeWidth.update);
        }
      });
  
      debug('resizeW init');
    },
  
    add(func) {
      resizeW.functions.push(func);
      resizeW.length = resizeW.functions.length;
    },
  
    remove(func) {
      resizeW.functions.splice(func, 1);
      resizeW.length = resizeW.functions.length;
    },
  
    update() {
      for (let i = 0; i < resizeW.length; i++) {
        let func = resizeW.functions[i];
        func();
      }
  
      resizeW.isRunning = false;
    },
  
  }
  
  
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function (e) {
        if (!scroll.isRunning) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame(WinScroll.update);
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      debug('scroll init');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      // website.winHeight = window.innerHeight;
      // website.scrollY = window.pageYOffset;
  
      for (let i = 0; i < scroll.length; i++) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  
  
  const OrientationChange = {
  
    init() {
      window.addEventListener('orientationchange', function (e) {
        if (!orientation.isRunning) {
          orientation.isRunning = true;
  
          orientation.animationFrame = window.requestAnimationFrame(OrientationChange.update);
        }
      });
  
      debug('orientationchange init');
    },
  
    add(func) {
      orientation.functions.push(func);
      orientation.length = orientation.functions.length;
    },
  
    remove(func) {
      orientation.functions.splice(func, 1);
      orientation.length = orientation.functions.length;
    },
  
    update() {
      for (let i = 0; i < orientation.length; i++) {
        let func = orientation.functions[i];
        func();
      }
  
      orientation.isRunning = false;
    },
  
  }
  
  
  const Modules = {
    
    init() {
      mod = {
        smooth: {
          trigger: 'js-scroll',
          speed: 600,
        },
      };
      debug('Modules init');
      this.setProperty();
      this.deviceCheck();
      // this.smoothScroll();
      this.viewportCheck();
    },
    loadEvent() {
    },
    resizeEvent() {
    },
    resizeWEvent() {
      Modules.setProperty();
    },
    scrollEvent() {
    },
  
    setProperty() {
      // viewport height
      let vh = website.winHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
  
      // scrollbar width 
      let element = document.createElement('div');
      element.style.visibility = 'hidden';
      element.style.overflow = 'scroll';
      document.body.appendChild(element);
      let scrollbarWidth = element.offsetWidth - element.clientWidth;
      document.body.removeChild(element);
      document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
    },
    viewportCheck() {
      if(website.winWidth < website.breakpoint.min) {
        document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=375, initial-scale=1, maximum-scale=2, user-scalable=yes, viewport-fit=cover');
      } else {
        document.querySelector('meta[name="viewport"]').setAttribute('content', website.viewport);
      }
    },
    gpuCheck() {
      const canvas = document.createElement("canvas");
      let gl;
      let renderer;
      try {
        gl = canvas.getContext("experimental-webgl");
        const ext = gl.getExtension("WEBGL_debug_renderer_info");
        if (!ext) {
          renderer = "";
        } else {
          renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
        }
      } catch (e) {
        gl = null;
        renderer = "";
      }
    },
    deviceCheck() {
      // iOS check
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        document.body.classList.add('is-ios');
      } else {
        document.body.classList.remove('is-ios');
      }
  
      // device check
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        website.isTablet = false;
        website.isMobile = true;
        document.body.classList.remove('is-tb','is-pc');
        document.body.classList.add('is-sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        website.isTablet = true;
        website.isMobile = false;
        document.body.classList.remove('is-pc','is-sp');
        document.body.classList.add('is-tb');
        if( website.tabletView !== false && typeof website.tabletView === 'number' ){
          document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=' + website.tabletView + ', initial-scale=1, maximum-scale=2, user-scalable=yes');
        }else {
          document.querySelector('meta[name="viewport"]').setAttribute('content', website.viewport);
        }
      } else {
        website.isDesktop = true;
        website.isTablet = false;
        website.isMobile = false;
        document.body.classList.remove('is-tb','is-sp');
        document.body.classList.add('is-pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function () {
        let href = $(this).attr("href"),
          target = $((href == "#") ? 'html' : href),
          shift = ((website.winWidth < website.shiftPoint) && (href != "#")) ? $(`#${website.headId}`).offsetHeight : 0,
          position = target.offset().top - shift;
  
        $('body,html').animate({ scrollTop: position }, mod.smooth.speed, 'swing');
        return false;
      });
    },
  
  }
  
  
  const DrawerMenu = {
  
    init() {
      drawer = {
        duration: 10,
  
        menu: 'js-drawerMenu',
        menuPanel: 'js-drawerMenuPanel',
        menuToggle: '#js-drawerMenuToggle',
        menuClose: '#js-drawerMenuPanel, #js-drawerMenu .js-scroll',
        menuAct: 'slideout-open',
        func: null
      };
      debug('DrawerMenu init');
      this.menu();
    },
  
    menu() {
      if (document.getElementById(drawer.menu) != null) {
        $('html').removeClass(drawer.menuAct);
        drawer.func = new Slideout({
          'panel': document.getElementById(drawer.menuPanel),
          'menu': document.getElementById(drawer.menu),
          'duration': drawer.duration,
          // 'openclass': drawer.menuAct,
        });
        let nodeList = document.querySelectorAll(drawer.menuToggle);
        let node = Array.prototype.slice.call(nodeList, 0);
        node.forEach(function (elem, index) {
          elem.addEventListener('click', function () {
            drawer.func.toggle();
          });
        });
        let nodeListClose = document.querySelectorAll(drawer.menuClose);
        let nodeClose = Array.prototype.slice.call(nodeListClose, 0);
        nodeClose.forEach(function (elem, index) {
          elem.addEventListener('click', function () {
            drawer.func.close();
          });
        });
        drawer.func.on('open', function(){
          iScroll.stop();
        });
        drawer.func.on('close', function(){
          iScroll.start();
        });
      }
    },
    close() {
      drawer.func.close();
    }
  }
  
  
  
  const Animation = {
  
    init() {
      anime = {
        // add: 'js-animeAdd',
  
        // loader: 'js-loader',
        // time: (website.page == 'top') ? 200: 200,
        // word: 'js-animeWord',
      };
  
      // this.addAnime();
      // this.word();
    },
  
    check() {
      $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function () {
        let self = $(this),
          targetPosition = self.offset().top,
          triggerPosition,
          shift;
  
        if (website.winWidth < website.shiftPoint) {
          shift = website.winHeight / website.shiftSp;
        } else {
          shift = website.winHeight / website.shiftPc;
        }
        triggerPosition = targetPosition - website.winHeight + shift;
        if(self.offset().top < website.winHeight) {
          self.addClass(website.actAnime);
        }
        if (website.scrollY > triggerPosition) {
          if (typeof self.data('delay') !== 'undefined') {
            self.css('transitionDelay', self.data('delay') + 'ms')
          }
          self.addClass(website.actAnime);
        }
      });
    },
    reset() {
      $('.' + website.targetAnime).removeClass(website.actAnime);
    }
  
  }
  
  
  const Accordion = {
    init() {
      accordion = {
        toggleElm: 'js-accordion',
        toggleSpElm: 'js-accordionSP',
        openElm: 'js-accordionOpen',
        closeElm: 'js-accordionClose',
        openClass: 'is-open',
        actClass: 'is-act',
        speed: 400,
      }
      debug('Accordion init');
      this.set();
      this.toggle();
      this.open();
      this.close();
    },
    set() {
      $('.' + accordion.toggleElm).each(function () {
        if($(this).hasClass('is-open')) {
          $(this).next().show();
        }
      });
    },
  
    toggle() {
      $(document).on('click', `.${accordion.toggleElm}`, function(){
        let target = $(this).attr('data-accordion-content');
        if(target && $(target).length) {
          $(this).toggleClass(accordion.openClass);
          $(target).stop().slideToggle(accordion.speed, 'swing');
        } else {
          $(this).toggleClass(accordion.openClass);
          $(this).next().stop().slideToggle(accordion.speed, 'swing');
        }
      });
    },
    open() {
      $(document).on('click', `.${accordion.openElm}`, function(){
        let target = $(this).attr('data-accordion-content');
        let targetClose = $(this).attr('data-accordion-close');
        if( target && $(target).length ){
          if ( !$(this).hasClass(accordion.actClass) ) {
            $(this).addClass(accordion.actClass);
            $(targetClose).addClass(accordion.actClass);
            $(target).stop().slideDown(accordion.speed, 'swing');
            return false;
          }
        }
      });
    },
    close() {
      $(document).on('click', `.${accordion.closeElm}`, function(){
        let target = $(this).attr('data-accordion-content');
        let targetOpen = $(this).attr('data-accordion-open');
        if( target && $(target).length ){
          if ( $(this).hasClass(accordion.actClass) ) {
            $(this).removeClass(accordion.actClass);
            $(targetOpen).removeClass(accordion.actClass);
            $(target).stop().slideUp(accordion.speed, 'swing');
            return false;
          }
        }
      });
    }
  }
  const Modal = {
    init() {
      modal = {
        targetElm: 'js-modal',
        openElm: 'js-modalOpen',
        closeElm: 'js-modalClose',
        overlayElm: 'js-modalOverlay',
        openClass: 'is-open',
        bodyOpenClass: 'is-modalOpen',
      },
      debug('Modal init');
      this.open();
      this.close();
    },
  
    open() {
      $(document).on('click', '.' + modal.openElm, function () {
        let target = $(this).attr('href');
        $('html').addClass(modal.bodyOpenClass);
        $('.' + modal.targetElm + target).addClass(modal.openClass);
        $('video')[0].pause();
        iScroll.stop();
        return false;
      });
    },
    close() {
      $(document).on('click', '.' + modal.closeElm + ', .' + modal.overlayElm, function () {
        $(this).closest('.' + modal.targetElm).removeClass(modal.openClass);
        $('html').removeClass(modal.bodyOpenClass);
        if($(this).closest('.' + modal.targetElm).find('iframe').length) {
          $(this).closest('.' + modal.targetElm).find('iframe').each(function(){
            if($(this).attr('src').indexOf('youtube') > -1 && $(this).attr('src').indexOf('enablejsapi=1') > -1) {
              const message = '{"event": "command", "func": "stopVideo", "args": ""}';
              $(this)[0].contentWindow.postMessage(message, '*');
            }
          });
        }
        $('video')[0].play();
        iScroll.start();
      });
    }
  }
  const Slider = {
    init() {
      slider = {
        common: {
  
        },
        home: {
          members: {
            targetId: 'js-sliderHomeMembers',
            options: {
              type: 'loop',
              perMove: 1,
              gap: "5rem",
              autoplay: true,
              speed: 1500,
              easing: 'cubic-bezier(0.23, 1, 0.32, 1)',
              interval: 6000,
              pagination: false,
              autoWidth: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              rewind: false,
              breakpoints: {
                991.9: {
                  gap: "3rem",
                },
                767.9: {
                  gap: "2.5rem",
                },
              },
            }
          }
        }
      }
      debug('Slider init');
      this.homeMembers();
    },
    homeMembers() {
      if(document.getElementById(slider.home.members.targetId)) {
        const splide = new Splide('#' + slider.home.members.targetId, slider.home.members.options);
        splide.mount();
      }
    }
  }
  const Pjax = {
    init() {
      pjax = {
        element: {
          header: {
            fixedClass: 'is-fixed', 
            whiteClass: 'is-white', 
            whiteSpClass: 'is-whiteSP', 
          },
          loader: {
            wrapperElm: 'js-loader',
            shortLineElm: 'js-loaderLineShort',
            longLineElm: 'js-loaderLineLong',
            backgroundElm: 'js-loaderBg',
            speed: 0.4,
          },
          overlay: {
            frontElm: 'js-overlayFront',
            backElm: 'js-overlayBack',
            speed: 0.4,
          },
        },
        hooks: {
          beforeOnce: [],     // 1. 読み込み前(初期読み込み時)
          once: [],           // 2. 読み込み完了(初期読み込み時)
          afterOnce: [],      // 3. 読み込み完了後(初期読み込み時)
          before: [],         // 4. ページ遷移の始まり
          beforeLeave: [],    // 5. ページ遷移の前
          leave: [],          // 6. 現在のページの離脱
          afterLeave: [],     // 7. 現在のページの離脱後 (次ページコンテナがある状態)
          beforeEnter: [],    // 8. 次ページに入る前
          enter: [],          // 9. 次ページに入った時
          afterEnter: [],     // 10. 次ページに入った後
          after: [],          // 11. すべて完了
        },
        debug: false,
      }
      if(website.isLocal) {
        pjax.debug = true;
      }
      debug('Pjax init');
      this.loaderInit();
      this.overlayInit();
      this.run();
      this.setHook();
      this.callHook();
    },
    run() {
      barba.init({
        debug: pjax.debug,
        transitions: [
          {
            name: 'default-transition',
            once(data) {
              debug('pjax once');
              WebGL.init();
              Common.navigationCurrent();
              WinResize.add(Modules.resizeEvent);
              WinResizeWidth.add(Modules.resizeWEvent);
              WinResizeWidth.add(WebGL.resizeWEvent);
              WinScroll.add( Animation.check );
              WinScroll.add( Common.scrollEvent );
              Pjax.pushStateGA();
            },
            beforeLeave(data) {
              debug('pjax beforeLeave');
              DrawerMenu.close();
            },
            afterLeave(data) {
              debug('pjax afterLeave');
              website.referrer = new URL(data.current.url.href);
              website.entry = "navigate";
              WinResize.remove(Modules.resizeEvent);
              WinResizeWidth.remove(Modules.resizeWEvent);
              WinResizeWidth.remove(WebGL.resizeWEvent);
              WinScroll.remove( Animation.check );
              WinScroll.remove( Common.scrollEvent );
              if( data.next.namespace === 'member' || data.next.namespace === 'voice' ) {
                Pjax.leaveAnimation(true);
                return new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                  }, pjax.element.overlay.speed * 1000 * 2);
                });
              } else {
                Pjax.leaveAnimation(false);
                return new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                  }, pjax.element.loader.speed * 1000 * 2);
                });
              }
            },
            beforeEnter(data) {
              debug('pjax beforeEnter');
              website.page = document.getElementById('js-container').dataset.barbaNamespace;
              Pjax.updateHead(data);
              Pjax.viewReset();
              Megamenu.close();
              DrawerMenu.menu();
              Common.navigationCurrent();
              WinResize.add(Modules.resizeEvent);
              WinResizeWidth.add(Modules.resizeWEvent);
              WinResizeWidth.add(WebGL.resizeWEvent);
              WinScroll.add( Animation.check );
              WinScroll.add( Common.scrollEvent );
              if( data.next.namespace === 'member' || data.next.namespace === 'voice' ) {
                Pjax.enterAnimation(true);
              } else {
                Pjax.enterAnimation(false);
              }
            },
            enter(data) {
              debug('pjax enter');
              Common.bgHide();
              Common.bgParallax();
            },
            after(data){
              debug('pjax after');
              Common.headerWhiteSPToggle();
              Common.headerLightBlueToggle();
              Animation.check();
              Pjax.videoAutoPlay();
              Pjax.pushStateGA();
              WebGL.init();
              if(typeof data.next.url.hash === "string") {
                const hash = '#' + data.next.url.hash;
                const position = $(hash).offset().top - $(`#${website.headId}`).outerHeight();
                if(website.winWidth < website.breakpoint.sp) {
                  setTimeout(function() {
                    window.scrollTo({
                      top: $(hash).offset().top - $(`#${website.headId}`).outerHeight(),
                      behavior: 'smooth'
                    });
                  }, 2000);
                } else {
                  window.scrollTo(0,position);
                }
              }
            }
          },
        ],
        views:[
          {
            namespace: 'home',
            afterLeave(data) {
              Home.fvSplineScriptRemove();
              WinResize.remove( Home.resizeEvent );
              WinScroll.remove( Home.scrollEvent );
              document.removeEventListener('touchmove', Home.scrollStop);
              document.removeEventListener('wheel', Home.scrollStop);
              document.removeEventListener('touchmove', Home.fvBgScroll);
              document.removeEventListener('wheel', Home.fvBgScroll);
              iScroll.start();
            },
            beforeEnter(data) {
              Home.init();
              if(website.entry === "reload" || (website.referrer && website.referrer.hostname === website.domain)) {
                page.home.shortAnime = true;
              }
              document.addEventListener('touchmove', Home.scrollStop, { passive: false });
              document.addEventListener('wheel', Home.scrollStop, { passive: false });
              document.addEventListener('touchmove', Home.fvBgScroll, { passive: true });
              document.addEventListener('wheel', Home.fvBgScroll, { passive: true });
            },
            afterEnter(data) {
              Home.loadEvent();
              Slider.homeMembers();
              WinResize.add( Home.resizeEvent );
              WinScroll.add( Home.scrollEvent );
            },
          },
          {
            namespace: 'member', 
            beforeEnter(data) {
            },
            afterEnter(data) {
              Member.init();
              Member.set();
              WinScroll.add( Member.scrollEvent );
            },
            afterLeave(data) {
              Member.scrollStopOff();
              WinScroll.remove( Member.scrollEvent );
            }
          }
        ],
      });
    },
    setHook() {
    },
    updateHead(data) {
      const updateElms = [
        'meta[name="robots"]',
        'meta[name="keywords"]',
        'meta[name="description"]',
        'meta[property^="og:"]',
        'meta[property^="fb"]',
        'meta[name^="twitter:"]',
        'link[rel="canonical"]',
        'script#breadcrumb_json',
      ].join(',');
  
      const currentHead = document.head;
      const nextHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
      const newHead = document.createElement('head');
      newHead.innerHTML = nextHead;
  
      // 旧headの要素を削除
      currentHead.querySelectorAll(updateElms).forEach((elm) => {
        currentHead.removeChild(elm);
      });
  
      // 新headの要素を追加
      newHead.querySelectorAll(updateElms).forEach((elm) => {
        currentHead.appendChild(elm);
      });
    },
    pushStateGA() {
      if(typeof window.GA_MEASUREMENT_IDs !== "undefined" && window.GA_MEASUREMENT_IDs.length) {
        window.GA_MEASUREMENT_IDs.forEach(function(mid,i) {
          gtag('event', 'page_view', {
            'page_title': document.title,
            'page_location': location.href,
            'page_path': location.pathname,
            'send_to': mid
          });
        });
      }
    },
    viewReset() {
      window.scrollTo(0,0);
    },
    videoAutoPlay() {
      if($('.js-videoElm').length) {
        $('.js-videoElm').each(function(){
          if($(this).attr('autoplay')) {
            $(this)[0].play();
          }
        });
      }
    },
    loaderInit() {
      gsap.set(`#${pjax.element.loader.backgroundElm}`, {
        scaleX: 0,
        transformOrigin: 'left center',
      });
      gsap.set(`.${pjax.element.loader.shortLineElm}`, {
        scaleX: 0,
        transformOrigin: 'left center',
      });
      gsap.set(`.${pjax.element.loader.longLineElm}`, {
        scaleX: 0,
        transformOrigin: 'left center',
      });
      gsap.set(`.${pjax.element.loader.longLineElm}`, {
        scaleX: 0,
        transformOrigin: 'left center',
      });
    },
    overlayInit() {
      gsap.set(`#${pjax.element.overlay.frontElm}`, {
        opacity: 0,
      });
      gsap.set(`#${pjax.element.overlay.backElm}`, {
        opacity: 0,
      });
    },
    leaveAnimation(member = false) {
      if(!member) {
        gsap.timeline()
        .to(`#${pjax.element.loader.backgroundElm}`, {
          scaleX: 1,
          duration: pjax.element.loader.speed,
          transformOrigin: 'left center',
          onStart: () => {
            $(`html`).removeClass(website.act);
            $(`#${pjax.element.loader.wrapperElm}`).addClass(website.act);
          },
        })
        .to(`.${pjax.element.loader.longLineElm}`, {
          scaleX: 1,
          duration: pjax.element.loader.speed/2,
          transformOrigin: 'left center',
        })
        .to(`.${pjax.element.loader.shortLineElm}`, {
          scaleX: 1,
          duration: pjax.element.loader.speed/2,
          transformOrigin: 'left center',
        }, `-=${pjax.element.loader.speed/2}`);
      } else {
        gsap.timeline()
        .to(`#${pjax.element.overlay.backElm}`, {
          opacity: 1,
          duration: pjax.element.overlay.speed,
          onStart: () => {
            $(`#${pjax.element.overlay.backElm}`).addClass(website.act);
          },
          onComplete: () => {
            $(`html`).removeClass(website.act);
          }
        })
        .to(`#${pjax.element.overlay.frontElm}`, {
          opacity: 1,
          duration: pjax.element.overlay.speed,
          onStart: () => {
            $(`#${pjax.element.overlay.frontElm}`).addClass(website.act);
          },
        });
      }
    },
    enterAnimation(member = false) {
      if(!member) {
        gsap.timeline()
        .to(`.${pjax.element.loader.longLineElm}`, {
          scaleX: 0,
          duration: pjax.element.loader.speed/2,
          transformOrigin: 'right center',
        })
        .to(`.${pjax.element.loader.shortLineElm}`, {
          scaleX: 0,
          duration: pjax.element.loader.speed/2,
          transformOrigin: 'right center',
        }, `-=${pjax.element.loader.speed/4}`)
        .to(`#${pjax.element.loader.backgroundElm}`, {
          scaleX: 0,
          duration: pjax.element.loader.speed,
          transformOrigin: 'right center',
          onComplete: () => {
            $(`html`).addClass(website.act);
            $(`#${pjax.element.loader.wrapperElm}`).removeClass(website.act);
          },
        });
      } else {
        gsap.timeline()
        .to(`#${pjax.element.overlay.frontElm}`, {
          opacity: 0,
          duration: pjax.element.overlay.speed,
          onComplete: () => {
            $(`#${pjax.element.overlay.frontElm}`).removeClass(website.act);
          },
        })
        .to(`#${pjax.element.overlay.backElm}`, {
          opacity: 0,
          duration: pjax.element.overlay.speed,
          onComplete: () => {
            $(`html`).addClass(website.act);
            $(`#${pjax.element.overlay.backElm}`).removeClass(website.act);
          },
        });
      }
    },
    addHook(hookname,func) {
      pjax.hooks[hookname].push(func);
    },
    callHook() {
      if(pjax.hooks.beforeOnce.length) {
        debug('pjax beforeOnce hook');
        barba.hooks.beforeOnce((data) => {
          pjax.hooks.beforeOnce.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.once.length) {
        debug('pjax once hook');
        barba.hooks.once((data) => {
          pjax.hooks.once.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.afterOnce.length) {
        debug('pjax afterOnce hook');
        barba.hooks.afterOnce((data) => {
          pjax.hooks.afterOnce.forEach((func) => {
            func(data);
          });
        });
  
      }
      if(pjax.hooks.before.length) {
        debug('pjax before hook');
        barba.hooks.before((data) => {
          pjax.hooks.before.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.beforeLeave.length) {
        debug('pjax beforeLeave hook');
        barba.hooks.beforeLeave((data) => {
          pjax.hooks.beforeLeave.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.leave.length) {
        debug('pjax leave hook');
        barba.hooks.leave((data) => {
          pjax.hooks.leave.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.afterLeave.length) {
        debug('pjax afterLeave hook');
        barba.hooks.afterLeave((data) => {
          pjax.hooks.afterLeave.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.beforeEnter.length) {
        debug('pjax beforeEnter hook');
        barba.hooks.beforeEnter((data) => {
          pjax.hooks.beforeEnter.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.enter.length) {
        debug('pjax enter hook');
        barba.hooks.enter((data) => {
          pjax.hooks.enter.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.afterEnter.length) {
        debug('pjax afterEnter hook');
        barba.hooks.afterEnter((data) => {
          pjax.hooks.afterEnter.forEach((func) => {
            func(data);
          });
        });
      }
      if(pjax.hooks.after.length) {
        debug('pjax after hook');
        barba.hooks.after((data) => {
          pjax.hooks.after.forEach((func) => {
            func(data);
          });
        });
      }
    },
  }
  const Megamenu = {
    init() {
      megamenu = {
        triggerElm: 'js-megamenu',
        wrapperElm: 'js-megamenuWrapper',
        speed: 200,
        openClass: 'is-megaOpen',
      }
      debug('Megamenu init');
      this.close();
      this.set();
    },
    set() {
      if(website.isDesktop) {
        $(document).on('mouseenter', `.${megamenu.triggerElm}`, function () {
          $(this).addClass(website.act);
          $(this).children(`.${megamenu.wrapperElm}`).stop().slideDown(megamenu.speed).addClass(website.act);
          $('html').addClass(megamenu.openClass);
        }).on('mouseleave', `.${megamenu.triggerElm}`, function () {
          $(this).removeClass(website.act);
          $(this).children(`.${megamenu.wrapperElm}`).stop().slideUp(megamenu.speed).removeClass(website.act);
          $('html').removeClass(megamenu.openClass);
        });
      } else {
        $(document).on('click', `.${megamenu.triggerElm} a`, function () {
          if( $(this).closest(`.${megamenu.triggerElm}`).hasClass(website.act) ) {
            $(this).closest(`.${megamenu.triggerElm}`).removeClass(website.act);
            $(this).siblings(`.${megamenu.wrapperElm}`).stop().slideUp(megamenu.speed).removeClass(website.act);
            $('html').removeClass(megamenu.openClass);
          } else {
            $(this).closest(`.${megamenu.triggerElm}`).addClass(website.act);
            $(this).siblings(`.${megamenu.wrapperElm}`).stop().slideDown(megamenu.speed).addClass(website.act);
            $('html').addClass(megamenu.openClass);
          }
        });
      }
    },
    close() {
      $('html').removeClass(megamenu.openClass);
      $(`.${megamenu.triggerElm}`).removeClass(website.act);
      $(`.${megamenu.wrapperElm}`).removeClass(website.act);
      $(`.${megamenu.wrapperElm}`).hide();
    }
  }
  const iScroll = {
    init() {
      iscroll = {
        func: new Lenis({
          // smoothTouch: true,
        }),
        smoothElm: "js-scroll",
      },
      requestAnimationFrame(iScroll.set);
      this.smoothScroll();
    },
    set(time) {
      iscroll.func.raf(time);
      requestAnimationFrame(iScroll.set);
    },
    start() {
      if(iscroll.func !== null) {
        iscroll.func.start();
        debug('iScroll start');
      }
    },
    stop() {
      if(iscroll.func !== null) {
        iscroll.func.stop();
        debug('iScroll stop');
      }
    },
    smoothScroll() {
      $(document).on('click', `.${iscroll.smoothElm}`, function(e) {
        e.preventDefault();
        const hash = $(this).attr('href');
        const shift = $(`#${website.headId}`).outerHeight();
        iscroll.func.scrollTo($(hash).offset().top - shift);
      });
    },
    move(position) {
      iscroll.func.scrollTo(position);
    },
  }
  const WebGL = {
    init() {
      webgl = {
        wrapperElm: 'js-bgEffect',
        canvas: null,
        sprites:[],
        total: 6,
        texture: {
          src: null,
          base: {
            width: 211,
            height: 162
          },
          natural: {
            width: 762,
            height: 612
          }
        },
        progress: 0,
        anime: false,
        resize: null,
      }
      debug('WebGL init');
      this.func();
    },
    resizeWEvent() {
      if(webgl.resize !== null) {
        clearInterval(webgl.resize);
      }
      webgl.resize = setTimeout(function(){
        if(webgl.canvas !== null) {
          webgl.canvas.ticker.stop();
          for(let i = 0; i < webgl.sprites.length; i++) {
            const sprite = webgl.sprites[i];
            WebGL.setSprite(sprite,i);
          }
          webgl.canvas.ticker.start();
          clearTimeout(webgl.resize);
        }
      },100);
    },
    func() {
      if(website.winWidth >= website.winHeight) {
        webgl.total = 10;
      }
      if(document.getElementById(webgl.wrapperElm) && webgl.canvas === null) {
        webgl.texture.src = document.getElementById(webgl.wrapperElm).dataset.effectSrc;
        setTimeout(function(){
          if( document.getElementById(webgl.wrapperElm).dataset.anime === "true" ) {
            webgl.anime = true;
          }
          WebGL.set();
          WebGL.generate();
          webgl.canvas.ticker.add(WebGL.update);
        },200);
      }
      debug('webgl active');
    },
    set() {
      webgl.canvas = new PIXI.Application({
        width: website.winWidth,
        height: website.winHeight,
        backgroundColor: 0x000000,
        backgroundAlpha: 1,
        transparent: true,
      });
      document.getElementById(webgl.wrapperElm).appendChild(webgl.canvas.view);
    },
    generate() {
      for(let i = 0; i < webgl.total; i++) {
        const sprite = PIXI.Sprite.from(webgl.texture.src);
        sprite.anchor.set(0.5);
        sprite.alpha = Math.random();
        sprite.blendMode = PIXI.BLEND_MODES.SCREEN;
        // custom prooerty
        sprite.alphaMode = -1;
        sprite.delay = Math.floor(Math.random() * 10);
  
        WebGL.setSprite(sprite,i);
        // debug(sprite.x,sprite.y);
        webgl.sprites.push(sprite);
        webgl.canvas.stage.addChild(sprite);
      }
    },
    setSprite(sprite, i) {
      let scaleRate;
      // サイズをランダムに設定
      if( website.winWidth >= website.winHeight ) {
        scaleRate = webgl.texture.base.width / webgl.texture.natural.width * website.winWidth / 1440;
        sprite.x = i % 6 !== 5 ? Math.random() * webgl.canvas.screen.width / 3 + webgl.canvas.screen.width / 3 * (i % 3) : webgl.canvas.screen.width - webgl.texture.natural.width * scaleRate / 2;
        sprite.y = i % 6 !== 4 ? Math.random() * webgl.canvas.screen.height / 2 + webgl.canvas.screen.height / 2 * (i % 6 < 3 ? 1 : 0) : webgl.texture.natural.height * scaleRate / 2;
      } else {
        scaleRate = webgl.texture.base.height / webgl.texture.natural.height * website.winHeight / 660 * 0.5;
        sprite.x = Math.random() * webgl.canvas.screen.width / 2 + webgl.canvas.screen.width / 2 * (i % 2);
        sprite.y = Math.random() * webgl.canvas.screen.height / 3 + webgl.canvas.screen.height / 3 * (i % 3);
        if( i % 3 !== 2 ) {
          sprite.x = Math.random() * webgl.canvas.screen.width / 3 + webgl.canvas.screen.width / 3 * 2 * (i % 2);
        }
      }
      sprite.scale.set( scaleRate + Math.random() * scaleRate * 0.5);
      sprite.speed = Math.random() * 0.01 + 0.01;
      sprite.rotation = Math.random() * Math.PI;
  
      return sprite;
    },
    update() {
      for(let i = 0; i < webgl.sprites.length; i++) {
        const sprite = webgl.sprites[i];
        if(webgl.anime && (sprite.alpha + sprite.alphaMode * sprite.speed >= 1 || sprite.alpha + sprite.alphaMode * sprite.speed <= 0) && sprite.delay > 0) {
          sprite.delay -= 0.1;
        } else if( webgl.anime && sprite.delay <= 0) {
          sprite.delay = Math.floor(Math.random() * 10);
          sprite.alphaMode *= -1;
        }
        if( 0 < sprite.alpha + sprite.alphaMode * sprite.speed && sprite.alpha + sprite.alphaMode * sprite.speed < 1) {
          sprite.alpha += sprite.alphaMode * sprite.speed;
        } else if( sprite.alpha + sprite.alphaMode * sprite.speed >= 1) {
          sprite.alpha = 1;
        } else if( sprite.alpha + sprite.alphaMode * sprite.speed <= 0) {
          sprite.alpha = 0;
          if(webgl.anime) {
            WebGL.setSprite(sprite,i);
          } else {
            sprite.alphaMode *= -1;
          }
        }
        webgl.sprites[i] = sprite;
      }
      webgl.progress += 0.1;
    },
  }
  // ./inc/_cursor.js

  // page
  const Common = {
    init() {
      page.common = {
        header: {
          fixedClass: 'is-fixed', 
          whiteClass: 'is-white', 
          white: {
            checkClass: "js-headerWhite",
            toggleClass: "is-white",
            triggerElm: "js-headerWhiteTrigger",
            inarea: false,
          },
          whiteSp: {
            checkClass: "js-headerWhiteSP",
            toggleClass: "is-whiteSP",
            triggerElm: "js-headerWhiteSPTrigger",
            inarea: false,
          },
          lightBlue: {
            checkClass: "js-headerLightBlue",
            toggleClass: "is-lightBlue",
            triggerElm: "js-headerLightBlueTrigger",
            inarea: false,
          }
        },
        gnav: {
          item: 'js-gnavItem',
        },
        stickyBlock: {
          wrapperElm: 'js-stickyBlocks',
          targetElm: 'js-stickyBlock',
        },
        mScroll: {
          wrapperElm: 'js-container',
          parallaxElm: 'js-parallax',
          speed : 0.1,
        },
        bgHide: {
          wrapperElm: 'js-bgHide',
        },
        bgParallax: {
          wrapperElm: 'js-bgParallax',
        },
        bgEffect: {
        },
        elmShuffle: {
          wrapperElm: 'js-elmShuffle',
        }
      };
      debug('Common init');
      if(website.page !== "home") {
        this.scrollEnabled();
      } 
      this.navigationCurrent();
      this.bgHide();
      this.headerLightBlueToggle();
      this.headerWhiteSPToggle();
      // this.momentumScroll();
      this.bgParallax();
      this.elmShuffle();
    },
    loadEvent() {
      
    },
    resizeEvent() {
  
    },
    scrollEvent() {
      Common.stickyBlock();
      Common.headerFixed();
      Common.bgHide();
      Common.headerLightBlueToggle();
      Common.headerWhiteSPToggle();
      Common.bgParallax();
    },
    scrollEnabled() {
      document.documentElement.classList.add(website.act);
    },
    stickyBlock() {
      if($(`.${ page.common.stickyBlock.wrapperElm}`).length  ) {
        $(`.${ page.common.stickyBlock.wrapperElm}`).each(function() {
          const start = $(this).offset().top,
                end   = start + $(this).outerHeight(),
                range = end - start,
                length = $(this).find(`.${ page.common.stickyBlock.targetElm}`).length,
                threshold = 1 / length;
          let progress = (website.scrollY - start + website.winHeight) / range;
          if(0 <= progress && progress < 1) {
            for(let i = 0; i < length; i++) {
              if(i*threshold <= progress && progress < (i+1) * threshold) {
                $(this).find(`.${ page.common.stickyBlock.targetElm}`).eq(i).css('--progress', (progress - (i * threshold)) *length);
                $(this).find(`.${ page.common.stickyBlock.targetElm}`).eq(i).addClass(website.act).siblings(`.${page.common.stickyBlock.targetElm}`).removeClass(website.act);
  
              } else if(i*threshold > progress) {
                $(this).find(`.${ page.common.stickyBlock.targetElm}`).eq(i).css('--progress', 0);
              } else if(progress >= (i+1) * threshold) {
                $(this).find(`.${ page.common.stickyBlock.targetElm}`).eq(i).css('--progress', 1);
              }
            }
          } else if( 1 <= progress ){
            $(this).find(`.${ page.common.stickyBlock.targetElm}`).css('--progress', 1);
          } else {
            $(this).find(`.${ page.common.stickyBlock.targetElm}`).css('--progress', 0);
          }
        });
      }
    },
    navigationCurrent() {
      const path = location.pathname;
      $(`.${page.common.gnav.item}`).removeClass(website.current);
      $(`.${page.common.gnav.item}`).each(function() {
        if(path.indexOf($(this).data('current')) > -1) {
          $(this).addClass(website.current);
        }
      });
    },
    headerFixed() {
      if(website.scrollY > 0) {
        $(`#${website.headId}`).addClass(page.common.header.fixedClass);
      } else {
        $(`#${website.headId}`).removeClass(page.common.header.fixedClass);
      }
    },
    headerWhite() {
      $(`#${website.headId}`).addClass(page.common.header.whiteClass);
    },
    headerWhiteRemove() {
      $(`#${website.headId}`).removeClass(page.common.header.whiteClass);
    },
    headerWhiteToggle() {
      if($(`#${website.headId}`).hasClass(`${page.common.header.white.checkClass}`)) {
        page.common.header.white.inarea = false;
        $(`.${page.common.header.white.triggerElm}`).each(function() {
          if( $(this).offset().top <= website.scrollY  && website.scrollY < $(this).offset().top + $(this).outerHeight()) {
            page.common.header.white.inarea = true;
          }
        });
        if(page.common.header.white.inarea) {
          $(`#${website.headId}`).addClass(`${page.common.header.white.toggleClass}`);
        } else {
          $(`#${website.headId}`).removeClass(`${page.common.header.white.toggleClass}`);
        }
      }
    },
    headerLightBlueToggle() {
      if($(`#${website.headId}`).hasClass(`${page.common.header.lightBlue.checkClass}`)) {
        page.common.header.lightBlue.inarea = false;
        $(`.${page.common.header.lightBlue.triggerElm}`).each(function() {
          if( $(this).offset().top <= website.scrollY  && website.scrollY < $(this).offset().top + $(this).outerHeight()) {
            page.common.header.lightBlue.inarea = true;
          }
        });
        if(page.common.header.lightBlue.inarea) {
          $(`#${website.headId}`).addClass(`${page.common.header.lightBlue.toggleClass}`);
        } else {
          $(`#${website.headId}`).removeClass(`${page.common.header.lightBlue.toggleClass}`);
        }
      }
    },
    headerWhiteSPToggle() {
      if($(`#${website.headId}`).hasClass(`${page.common.header.whiteSp.checkClass}`) && website.winWidth < website.breakpoint.sp) {
        page.common.header.whiteSp.inarea = false;
        $(`.${page.common.header.whiteSp.triggerElm}`).each(function() {
          if( $(this).offset().top <= website.scrollY  && website.scrollY < $(this).offset().top + $(this).outerHeight()) {
            page.common.header.whiteSp.inarea = true;
          }
        });
        if(page.common.header.whiteSp.inarea) {
          $(`#${website.headId}`).addClass(`${page.common.header.whiteSp.toggleClass}`);
        } else {
          $(`#${website.headId}`).removeClass(`${page.common.header.whiteSp.toggleClass}`);
        }
      }
    },
    bgHide() {
      if($(`.${page.common.bgHide.wrapperElm}`).length) {
        $(`.${page.common.bgHide.wrapperElm}`).each(function() {
          let threshold;
          if($(this).data('threshold')) {
            threshold = $(this).data('threshold');
          } else {
            threshold = 1;
          }
          if(website.scrollY + website.winHeight * threshold > $(this).offset().top + $(this).outerHeight()) {
            $(this).addClass(website.hide);
          }else {
            $(this).removeClass(website.hide);
          }
        });
      }
    },
    bgParallax() {
      if($(`.${page.common.bgParallax.wrapperElm}`).length) {
        $(`.${page.common.bgParallax.wrapperElm}`).each(function() {
          let rate =  website.winHeight / $(this).outerHeight();
          if(website.winWidth < website.breakpoint.sp) {
            rate *= 0.5;
          }
          $(this).css({
            'background-position': `left top ${-1*website.scrollY*rate}px`,
          })
        });
      }
    },
    elmShuffle() {
      if($(`.${page.common.elmShuffle.wrapperElm}`).length) {
        $(`.${page.common.elmShuffle.wrapperElm}`).each(function() {
          const clones = $(this).children().clone(true);
          $(this).html('');
          const childObj = [...clones];
          const children = childObj.reduce((_, current, index) => {
            let rand = Math.floor(Math.random() * (index + 1));
            childObj[index] = childObj[rand];
            childObj[rand] = current;
            return childObj;
          });
          for(let i = 0; i < children.length; i++ ) {
            $(this).append(children[i]);
          }
        });
      }
    },
  }
  
  const Home = {
    init() {
      page.home = {
        header: 'js-header',
        loader: {
          targetElm: 'js-homeLoader',
          imgElm: 'js-homeLoaderImg',
        },
        background : {
          targetElm: 'js-homeBg',
          imgElm: 'js-homeBgImg',
          canvasElm: 'js-homeBgCanvas',
          class: {
            phase0: 'is-phase0',
            phase1: 'is-phase1',
            phase2: 'is-phase2', 
            phase3: 'is-phase3',
          },
          scriptId: 'spline_js',
        },
        hero: {
          targetElm: 'js-homeHero',
          textElmPC: 'js-homeHeroTxtPC',
          textElmSP: 'js-homeHeroTxtSP',
          newsElm: 'js-homeNews',
          scrollElm: 'js-homeHeroScroll',
        },
        main: {
          targetElm: 'js-homeMain',
        },
        about: {
          targetElm: 'js-homeAbout',
        },
        shortAnime: false,
      };
      iScroll.stop();
      $('html').removeClass(website.act);
      setTimeout(() => {
        window.scrollTo(0, 0);
      },100);
    },
    readyEvent() {
      // document.addEventListener('touchmove', (e) => {
      //   if(!$('html').hasClass(website.act)) {
      //     e.preventDefault();
      //   }
      // }, { passive: false });
      // document.addEventListener('touchmove', Home.fvBgScroll, { passive: true });
      // document.addEventListener('wheel', (e) => {
      //   if(!$('html').hasClass(website.act)) {
      //     e.preventDefault();
      //   }
      // }, { passive: false });
      // document.addEventListener('wheel', Home.fvBgScroll , { passive: true });
  
    },
    loadEvent() {
      setTimeout(() => {
        Home.fvAnimeInit();
        Home.fvAnimeSet();
      },100);
    },
    resizeEvent() {
  
    },
    scrollEvent() {
      Home.fvBgHide();
    },
    scrollStop(e) {
      if(!$('html').hasClass(website.act)) {
        e.preventDefault();
      }
    },
    fvAnimeInit() {
      Home.fvSplineAnime();
      Animation.reset();
      if(!page.home.shortAnime) {
        gsap.timeline()
            .set(`#${page.home.header}`, {
              opacity: 0,
              yPercent: -100,
            })
            .set(`#${page.home.hero.newsElm}`, {
              opacity: 0,
              yPercent: 100,
            })
            .set(`#${page.home.hero.scrollElm}`, {
              opacity: 0,
              yPercent: -100,
            })
      }
    },
    fvAnimeSet() {
      if(page.home.shortAnime) {
        Home.fvLoadingCallBack();
      } else {
        gsap.timeline()
            .from ( `#${page.home.loader.imgElm}`, { 
              opacity: 0, 
              scale: 0.8, 
            })
            .from ( `#${page.home.loader.targetElm}`, {
              opacity: 1,
            })
            .to( `#${page.home.loader.imgElm}`, { 
              opacity: 1, 
              scale: 1, 
              duration: 0.6,
            })
            .to( `#${page.home.loader.targetElm}`, { 
              opacity: 0, 
              duration: 0,
              delay: 0.1,
              onComplete: () => {
                Home.fvLoadingCallBack();
              },
            })
      }
    },
    fvLoadingCallBack() {
      $(`#${page.home.loader.targetElm}`).hide();
      Home.fvBgAnime();
      Home.fvBgHide();
      setTimeout(() => {
        Home.fvTxtAnime();
        setTimeout(() => {
          Home.fvHeaderAnime();
          Home.fvNewsAnime();
          setTimeout(() => {
            Home.fvScrollAnime();
            setTimeout(() => {
              document.documentElement.classList.add(website.inact);
            }, 100 );
          }, 500 * 1.5);
        }, 600 * 1.5);
      }, 300)
    },
    fvSplineAnime() {
      const script = document.createElement('script');
      const js = document.getElementById(page.home.background.canvasElm).getAttribute('data-spline-src');
      const scene = document.getElementById(page.home.background.canvasElm).getAttribute('data-spline-object');
      const module = `
        import {
          Application
        } from '${js}';
        const canvas = document.getElementById('js-webglHomeBg');
        const app = new Application(canvas);
        app.load('${scene}');
      `;
      script.setAttribute('type', 'module');
      script.id = page.home.background.scriptId;
      script.innerHTML = module;
      document.body.appendChild(script);
    },
    fvSplineScriptRemove() {
      document.getElementById(page.home.background.scriptId).remove();
    },
    fvBgAnime() {
      if(!page.home.shortAnime) {
        $(`#${page.home.background.targetElm}`).addClass(page.home.background.class.phase0);
        setTimeout(() => {
          $(`#${page.home.background.targetElm}`).addClass(page.home.background.class.phase1);
        },100)
      } else {
        $(`#${page.home.background.targetElm}`).addClass(page.home.background.class.phase1);
      }
    },
    fvTxtAnime() {
      const json_pc = document.getElementById(page.home.hero.textElmPC).getAttribute('data-src');
      const json_sp = document.getElementById(page.home.hero.textElmSP).getAttribute('data-src');
      const pcAnimation = lottie.loadAnimation({
        container: document.getElementById(page.home.hero.textElmPC),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: json_pc,
        // path: './assets/attachment/home/json/hero_txt_02_pc.json',
      });
      const spAnimation = lottie.loadAnimation({
        container: document.getElementById(page.home.hero.textElmSP),
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: json_sp,
        // path: './assets/attachment/home/json/hero_txt_02_sp.json',
      });
      pcAnimation.onComplete = () => {
        document.getElementById(page.home.hero.textElmPC).classList.add(website.act);
      }
      spAnimation.onComplete = () => {
        document.getElementById(page.home.hero.textElmSP).classList.add(website.act);
      }
    },
    fvHeaderAnime() {
      if(!page.home.shortAnime) {
        gsap.to(`#${page.home.header}`, {
          opacity: 1,
          yPercent: 0,
          duration: 0.5,
        });
      }
    },
    fvNewsAnime() {
      gsap.to(`#${page.home.hero.newsElm}`, {
        opacity: 1,
        yPercent: 0,
        duration: 0.5,
      });
    },
    fvScrollAnime (){
      gsap.to(`#${page.home.hero.scrollElm}`, {
        opacity: 1,
        yPercent: 0,
        duration: 0.5,
      });
    },
    fvBgScroll () {
      if($('html').hasClass(website.inact)) {
        $('html').removeClass(website.inact);
        $(`#${page.home.background.targetElm}`).addClass(page.home.background.class.phase2);
        Common.headerWhite();
        $(`#${page.home.hero.targetElm}`).fadeOut(400);
        $(`#${page.home.hero.newsElm}`).fadeOut(400);
        setTimeout(()=> {
          $(`#${page.home.main.targetElm}`).addClass(website.act);
          setTimeout(() => {
            $('html').addClass(website.act);
            iScroll.start();
            window.scrollTo(0,1);
          }, 400);
        },400);
      }
    },
    fvBgHide () {
      if( $(`#${page.home.background.targetElm}`).hasClass(page.home.background.class.phase2) && $(`#${page.home.main.targetElm}`).hasClass(website.act) ) {
        let shift;
        if (website.winWidth < website.shiftPoint) {
          shift = website.winHeight / website.shiftSp;
        } else {
          shift = website.winHeight / website.shiftPc;
        }
        if(website.scrollY + website.winHeight - shift > $(`#${page.home.about.targetElm}`).offset().top + $(`#${page.home.about.targetElm}`).outerHeight()) {
          $(`#${page.home.background.targetElm}`).addClass(page.home.background.class.phase3);
          Common.headerWhiteRemove();
        } else {
          $(`#${page.home.background.targetElm}`).removeClass(page.home.background.class.phase3);
          Common.headerWhite();
        }
      }
    }
  }
  
  const Member = {
    init() {
      page.member = {
        background: {
          wrapperElm: 'js-memberBackground',
          imgMainElm: 'js-memberBackgroundMain',
          imgSubElm: 'js-memberBackgroundSub',
        },
        head: {
          wrapperElm: 'js-memberHeadFrame',
        },
        main: {
          wrapperElm: 'js-memberMainFrame',
        },
        options: {
          fadeIn: {
            speed: 1,
            delay: 0.1,
          },
          fadeOut: {
            speed: 0.4,
            delay: 0,
          },
          hide: {
            speed: 0.4,
          }
        },
        anime: false,
        complete: false,
      }
      debug('Member init');
    },
    set() {
      Member.viewInit();
      // Member.scrollStopOn();
    },
    scrollEvent() {
      Member.bgHide();
      if(website.winWidth < website.winHeight) {
        Member.scrollAnime();
      } else {
        Member.wheelAnime();
      }
    },
    scrollStop(e) {
      console.log(e);
      if(e.type === 'wheel') {
        debug('Member ScrollStop');
        iScroll.stop();
        e.preventDefault();
      } else if(e.type === 'touchmove' && website.winWidth >= website.winHeight) {
        debug('Member ScrollStop');
        iScroll.stop();
        e.preventDefault();
      }
      if(!page.member.anime) {
        Member.wheelAnime(e);
      }
    },
    scrollStopOn() {
      // document.addEventListener('wheel', Member.scrollStop, { passive: false });
      // if(website.isTouch) {
      //   document.addEventListener('touchmove', Member.scrollStop, { passive: false });
      // }
    },
    scrollStopOff() {
      // iScroll.start();
      // document.removeEventListener('wheel', Member.scrollStop);
      // document.removeEventListener('touchmove', Member.scrollStop);
      // debug('Member ScrollStopOff');
    },
    viewInit() {
      gsap.set( `#${page.member.background.wrapperElm}`, {
        opacity: 1,
      });
      gsap.timeline()
          .set( `#${page.member.background.imgSubElm}`, {
            opacity: 0,
          })
          .set( `#${page.member.main.wrapperElm}`, {
            opacity: 0,
          })
          .set( `#${page.member.background.imgMainElm}`, {
            opacity: 1,
          })
          .set( `#${page.member.head.wrapperElm}`, {
            opacity: 1,
          })
    },
    wheelAnime() {
      gsap.timeline()
          .to( `#${page.member.background.imgMainElm}`, {
            opacity: 0,
            duration: page.member.options.fadeOut.speed,
            delay: page.member.options.fadeOut.delay,
            onStart: () => {
              page.member.anime = true;
            }
          })
          .to( `#${page.member.head.wrapperElm}`, {
            opacity: 0,
            duration: page.member.options.fadeOut.speed,
          }, `-=${page.member.options.fadeOut.speed}`)
          .to( `#${page.member.background.imgSubElm}`, {
            opacity: 1,
            duration: page.member.options.fadeIn.speed,
            delay: page.member.options.fadeIn.delay,
          })
          .to( `#${page.member.main.wrapperElm}`, {
            opacity: 1,
            duration: page.member.options.fadeIn.speed,
            onStart: () => {
              Member.scrollStopOff();
              page.member.anime = false;
              page.member.complete = true;
            }
          }, `-=${page.member.options.fadeIn.speed}`);
    },
    scrollAnime() {
      if(!page.member.anime) {
        if(website.scrollY >= website.winHeight * 0.5) {
          gsap.to( `#${page.member.background.imgMainElm}`, {
            opacity: 0,
            duration: page.member.options.hide.speed,
            onStart: () => {
              page.member.anime = true;
            },
            onComplete: () => {
              page.member.anime = false;
            }
          });
        } else {
          gsap.to( `#${page.member.background.imgMainElm}`, {
            opacity: 1,
            duration: page.member.options.hide.speed,
            onStart: () => {
              page.member.anime = true;
            },
            onComplete: () => {
              page.member.anime = false;
            }
          });
        }
      }
    },
    bgHide() {
      const container = $(`#${page.member.main.wrapperElm}`);
      if( page.member.complete && website.scrollY > container.outerHeight() * .75 + container.offset().top ) {
        gsap.timeline()
            .to( `#${page.member.background.wrapperElm}`, {
              opacity: 0,
              duration: page.member.options.hide.speed,
            });
      } else {
        gsap.timeline()
            .to( `#${page.member.background.wrapperElm}`, {
              opacity: 1,
              duration: page.member.options.hide.speed,
            });
      }
    }
  }

  const App = {

    init() {
      if (website.page != 'wp-manual' && website.page != 'wp-manual-single') {
        this.set();
        this.update();
      } else {
        // Modules.init();
        Wordpress.init();
      }
    },

    set() {
      Modules.init();
      iScroll.init();
      DrawerMenu.init();
      Common.init();
      Accordion.init();
      Modal.init();
      Slider.init();
      Megamenu.init();
      Pjax.init();

      WinLoad.add( Animation.check );
      WinLoad.add( Modules.loadEvent );
      
      // OrientationChange.add( xxx );

      WinReady.init();
      WinLoad.init();
      WinResize.init();
      WinResizeWidth.init();
      WinScroll.init();
      OrientationChange.init();

    },

    update() {
      website.animationFrame = window.requestAnimationFrame(App.update);

      website.winWidth = window.innerWidth;
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;

      website.scrollHeight = document.documentElement.scrollHeight;
      website.scrollHiddenHeight = website.scrollHeight - website.winHeight;
      website.scrollRate = Math.round((website.scrollY / website.scrollHiddenHeight) * 100);

      // if (website.isDesktop) {
      //   PageScroll.smooth();

      //   if (mod.cursorMagnet) {
      //     Modules.cursorMagnet();
      //   }

      //   if (website.page == 'top') {
      //     Parallax.deviateScroll();
      //   }
      // }
    }

  }


  App.init();

})();


})(jQuery);
